import { renewalRefreshToken } from '~/features/auth/apis/auth'

type Props = {
  children: React.ReactNode
}

function RefreshRouter({ children }: Props) {
  const refreshToken = localStorage.getItem('starlike-refresh-token') || ''

  renewalRefreshToken(refreshToken)

  return <>{children}</>
}

export default RefreshRouter
